import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Sientes que algo en tu vida no encaja, pero no sabes qué es', 'Repites situaciones que no entiendes: relaciones, decisiones, emociones', 'Hay momentos de ansiedad, vacío o desconexión contigo', 'Has probado muchas cosas, pero sigues sin encontrar respuestas reales'];
export function PainPoints() {
  return <section className="bg-stone-900 py-16 sm:py-24 overflow-hidden" data-id="element-235">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center" data-id="element-236">
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-violet-300/80 text-sm uppercase tracking-widest font-medium mb-6" data-id="element-237">
          Quizás te reconoces
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif text-white leading-tight mb-10 sm:mb-16" data-id="element-238">
          Si estás aquí, probablemente{' '}
          <span className="italic text-violet-200" data-id="element-239">te está pasando esto</span>
        </motion.h2>

        <div className="space-y-6 sm:space-y-8" data-id="element-240">
          {painPoints.map((point, index) => <motion.p key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15 * index
        }} className="text-stone-300 text-base sm:text-lg md:text-xl font-light leading-relaxed" data-id="element-241">
              {point}
            </motion.p>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-14 sm:mt-20 pt-8 sm:pt-12 border-t border-stone-800/60" data-id="element-242">
          <p className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-serif italic leading-relaxed" data-id="element-243">
            Y lo peor no es lo que sientes:
            <br data-id="element-244" />
            <span className="text-violet-300" data-id="element-245">
              es no entender por qué te pasa.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}